import { Box } from '@mui/material';
import { StatusInfo } from '@features/workspace/components/shared/status-info';

export function LatestProductStatus({ productInfo }: any) {
  return (
    <>
      {productInfo && (
        <Box
          alignItems="end"
          display="flex"
          flexDirection="column"
          height="100%"
        >
          <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
            height="100%"
            style={{
              fontWeight: 400,
              fontSize: '12px',
            }}
          >
            <StatusInfo
              showIcon
              isCompleted={productInfo.isCompleted}
              text={productInfo.statusText}
            />

            {productInfo?.startDate}
          </Box>
        </Box>
      )}
    </>
  );
}
